<h1 mat-dialog-title>Dienst kopiëren</h1>
<div>
  <div mat-dialog-content>
    <form [formGroup]="copyForm">
      <mat-form-field>
        <mat-label>Wekelijks of om de week</mat-label>
        <mat-select formControlName="copyType" required>
          <mat-option [value]="'weekly'">Wekelijks</mat-option>
          <mat-option [value]="'everyOtherWeek'">Om de week</mat-option>
        </mat-select>
        @if (copyForm.controls.copyType.hasError('required')) {
          <mat-error>Dit veld is verplicht.</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Aantal kopieën</mat-label>
        <input formControlName="copyTimes" type="number" autocomplete="off" min="1" step="1" matInput required />
        @if (copyForm.controls.copyTimes.hasError('required')) {
          <mat-error>Dit veld is verplicht.</mat-error>
        }
      </mat-form-field>
    </form>
    @if (dateSequence().length > 0 || rebuildingSequence()) {
      <div class="date-sequence-wrapper">
        <div class="date-sequence-title">Datumreeks</div>
        @if (!rebuildingSequence()) {
          <mat-chip-listbox>
            @for (dateString of dateSequence().slice(0, 4); track dateString) {
              <mat-chip
                [class.date-warning]="
                  warnings()[dateString]?.status === 'finished' ||
                  warnings()[dateString]?.doubleBooking ||
                  warnings()[dateString]?.exception
                "
                [class.secondary-color]="
                  (warnings()[dateString]?.status === 'updated' || warnings()[dateString]?.status === 'removed') &&
                  !warnings()[dateString]?.doubleBooking &&
                  !warnings()[dateString]?.exception
                "
                [matTooltip]="warnings()[dateString]?.message"
              >
                {{ dateString }}
              </mat-chip>
            }
            @if (dateSequence().length > 4) {
              <div class="chip-overflow">...</div>
            }
          </mat-chip-listbox>
          @if (dateSequence().length > 4) {
            <div class="view-more-wrapper">
              <button mat-flat-button class="secondary-color" (click)="viewDateSequence()">Bekijk alle datums</button>
            </div>
          }
        } @else {
          <p class="date-impact">Datums worden gecontroleerd...</p>
        }
      </div>
    }
    <mat-error class="custom-message error-color">{{ customMessage() }}</mat-error>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]>Annuleren</button>
    <button
      mat-flat-button
      [disabled]="
        !copyForm.valid ||
        rebuildingSequence() ||
        dateSequence().length === 0 ||
        hasNoViableCopyDates() ||
        copyInProgress()
      "
      [class.spinner]="copyInProgress()"
      (click)="copyDaypart()"
    >
      Kopiëren
    </button>
  </div>
</div>
